import React, { useRef, useCallback, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useGeolocated } from "react-geolocated";
import axios from "axios";
import Webcam from "react-webcam";
import { BASE_URL } from "../../../config/axios";
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import { formattedDate, formattedDateLong } from "../../Date";
import usePermission from "../../../config/permissions";
import { customSortByKey, handleAllError, handleErrorToast, showConfirmToast } from "../../CustomFunctions";
import { CustomCSSForSearchableSelect } from "../../CustomUtilities";



const Clockin = ({ handleClose }) => {

  const webcamRef = useRef(null);

  const [locationData, setLocationData] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 5000,
    });



  const getLocation = async () => {
    try {
      const { latitude, longitude } = coords;
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyBwmmybQWla4yJB38xB3HvzLTQwyZf14JI`;
      const response = await fetch(url);
      const data = await response.json();
      console.log(data);
      if (data.status === "OK") {
        setLocationData(data.results[0].formatted_address);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  const formattedTime = today.toTimeString().split(" ")[0];

  const [formData, setFormData] = useState({
    employee: sessionStorage.getItem("emp_code"),
    date: formattedDate,
    punch_time: formattedTime,
    placename: locationData,
    sub_company: sessionStorage.getItem("company_id"),
  });

  useEffect(() => {
    getLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coords, isGeolocationAvailable, isGeolocationEnabled]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      placename: locationData,
    }));
  }, [locationData]);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImageSrc(imageSrc);
    return imageSrc;
  }, [webcamRef]);

  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); //loading logic

    const imageSrc = capture(); // Capture the image when submit is clicked

    const updatedFormValue = {
      ...formData,
      employee: sessionStorage.getItem("emp_code"),
      date: formattedDate,
      punch_time: formattedTime,
      placename: locationData,
    };

    const formDataToSend = new FormData();
    for (const key in updatedFormValue) {
      formDataToSend.append(key, updatedFormValue[key]);
    }
    // if (imageSrc) {
    //   const blob = await fetch(imageSrc).then((res) => res.blob());
    //   formDataToSend.append('image', blob, 'clockin_photo.jpg');
    // }

    if (imageSrc) {
      const blob = await fetch(imageSrc).then((res) => res.blob());
      const empCode = sessionStorage.getItem("emp_code");
      const filename = `${formattedDate}_${formattedTime}_${empCode}.jpg`;
      formDataToSend.append("image", blob, filename);
    }
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.post(
        `${BASE_URL}/wfm/clockinlog/`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res.status === 200) {
        console.log(res);
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <div className="clockin-div">
      <form onSubmit={handleSubmit} className="register-form">
        <div className="flex-column">
          <label htmlFor="employee" className="form-labels  font-weight500    font-size-subheading">
            Employee
          </label>
          <input
            id="employee"
            type="text"
            name="employee"
            readOnly
            value={sessionStorage.getItem("emp_code")}
            className="form-input   font-weight500   form-input-background"
          />
        </div>
        <div className="flex-column">
          <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
            Date
          </label>
          <input
            id="date"
            type="date"
            name="date"
            readOnly
            value={formattedDate}
            className="form-input   font-weight500   form-input-background"
          />
        </div>
        <div className="flex-column">
          <label htmlFor="punch_time" className="form-labels  font-weight500    font-size-subheading">
            Time
          </label>
          <input
            type="time"
            id="punch_time"
            name="punch_time"
            readOnly
            value={formattedTime}
            className="form-input   font-weight500   form-input-background"
          />
        </div>
        <div className="flex-column">
          <label htmlFor="placename" className="form-labels  font-weight500    font-size-subheading">
            Location
          </label>
          <input
            id="placename"
            name="placename"
            readOnly
            value={locationData}
            className="form-input   font-weight500   form-input-background"
          />
        </div>

        <div
          className="flex-column"
          style={{ justifyContent: "center", alignItems: "center" }}
        >
          <Webcam
            className="Clockin-Webcam"
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            width={400}
            height={300}
          />
        </div>
        <div className="button-models">
          <button type="button" className="model-button   font-weight500   " onClick={handleClose}>
            Close
          </button>
          {formattedTime && locationData ? (
            <button
              type="submit"
              disabled={loading}
              className="model-button   font-weight500    model-button-submit"
            >
              Submit
            </button>
          ) : (
            <div className="spinner-small"></div>
          )}
        </div>
      </form>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

    </div>
  );
};

const Leave = ({ handleClose }) => {
  const [buffer, setBuffering] = useState(false); // loading logic
  const [loading, setLoading] = useState(false); // loading logic
  const [leavebalance, setLeavebalance] = useState({});
  const [age, setAge] = useState('single');
  const [maxEndDate, setMaxEndDate] = useState(null);
  const [dateselectionError, setDateselectionError] = useState("");
  const [dateselectionConfirmation, setDateselectionConfirmation] = useState(false);
  const [insufficientBalanceError, setInsufficientBalanceError] = useState("");
  const [insufficientBalanceConfirmation, setInsufficientBalanceConfirmation] = useState(false);
  const [isDateAdjusted, setIsDateAdjusted] = useState(false);
  // Add state to track which cards are expanded
  const [expandedCards, setExpandedCards] = useState({
    previous: true,
    earned: true,
    casual: true,
    sick: true,
    short: false
  });

  const { PORTAL_SETTINGS } = usePermission();

  useEffect(() => {
    if (age === "shortleave") {
      setExpandedCards({
        previous: false,
        earned: false,
        casual: false,
        sick: false,
        short: true
      });
    } else {
      setExpandedCards({
        previous: true,
        earned: true,
        casual: true,
        sick: true,
        short: false
      });
    }
  }, [age]);

  const initialData = {
    empcode: sessionStorage.getItem("emp_code"),
    date: "",
    end_date: "",
    remarks: "",
  }

  const [dataa, setdataa] = useState({
    empcode: sessionStorage.getItem("emp_code"),
    date: "",
    end_date: "",
    remarks: "",
  });


  const getLeavebalance = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/leavebalance/${sessionStorage.getItem("emp_code")}/`);
      setLeavebalance(res.data);
    } catch (err) {
      // alert(err.message);
    }
  };

  useEffect(() => {
    getLeavebalance();
  }, []);


  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "empcode",
      "date",
      "leave_type",
      "remarks",
    ];
    requiredFields.forEach((field) => {
      if (!dataa[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    if (!dataa.remarks.trim()) {
      newErrors.remarks = "Remarks cannot be empty or contain only spaces!";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const getEndTime = (intime) => {
    const start = new Date(`2024-03-25T${intime}`);
    const end = new Date(start.getTime() + 2 * 60 * 60 * 1000); // Add 2 hours in milliseconds
    const hh = String(end.getHours()).padStart(2, "0");
    const mm = String(end.getMinutes()).padStart(2, "0");
    const ss = String(end.getSeconds()).padStart(2, "0");

    setdataa({ ...dataa, in_time: intime, out_time: `${hh}:${mm}:${ss}` });
  };

  const date = new Date();

  const [remarksError, setRemarksError] = useState("");
  const [typeError, setTypeError] = useState("");

  let lastDateOfPreviousMonth;
  if (date.getDate() > 25) {
    lastDateOfPreviousMonth = new Date(date.getFullYear(), date.getMonth(), 0);
  } else {
    lastDateOfPreviousMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  }
  const formattedLastDate = lastDateOfPreviousMonth.toISOString().substr(0, 10);

  const toLocalISODate = (date) => {
    if (!date || isNaN(date.getTime())) return "";
    const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return local.toISOString().split("T")[0];
  };

  const isFullValidDate = (val) => {
    return /^\d{4}-\d{2}-\d{2}$/.test(val) && !isNaN(new Date(val).getTime());
  };

  const getDateLimitsNoRestrictions = (startDate) => {
    const isFullValidDate = (val) =>
      /^\d{4}-\d{2}-\d{2}$/.test(val) && !isNaN(new Date(val).getTime());

    const today = new Date();
    // const referenceDate = startDate ? new Date(startDate) : today;
    const referenceDate = isFullValidDate(startDate)
      ? new Date(startDate)
      : today;

    const getMinDate = () => {
      if (PORTAL_SETTINGS?.leave_apply_past_limit) {
        const date = new Date(today);
        date.setDate(date.getDate() - parseInt(PORTAL_SETTINGS.leave_apply_past_limit) + 1);
        return date.toISOString().split("T")[0];
      }
      return null;
    };
    // const getMaxDate = () => {
    //   if (PORTAL_SETTINGS?.leave_apply_future_limit) {
    //     const date = new Date(referenceDate);
    //     date.setDate(date.getDate() + parseInt(PORTAL_SETTINGS.leave_apply_future_limit) + 1);
    //     return date.toISOString().split("T")[0];
    //   }
    //   return null;
    // };

    // const getMaxStartDate = () => {
    //   let maxByFutureLimit = null;

    //   if (PORTAL_SETTINGS?.leave_apply_future_limit) {
    //     const date = new Date(today);
    //     date.setDate(date.getDate() + parseInt(PORTAL_SETTINGS.leave_apply_future_limit + 1));
    //     maxByFutureLimit = date;
    //   }

    //   // If no future limit is set, allow indefinitely (no restriction)
    //   const finalMaxDate = maxByFutureLimit || new Date("2999-12-31");

    //   return finalMaxDate.toISOString().split("T")[0];
    // };

    const getMaxStartDate = () => {
      let maxByFutureLimit = null;

      if (PORTAL_SETTINGS?.leave_apply_future_limit) {
        const date = new Date(today);
        date.setDate(date.getDate() + parseInt(PORTAL_SETTINGS.leave_apply_future_limit + 1));
        maxByFutureLimit = date;
      }

      // Default cap: exactly one year from today, instead of the old "2999-12-31" (no real limit)
      const oneYearFromToday = new Date(today);
      oneYearFromToday.setDate(oneYearFromToday.getDate() + 365);

      const finalMaxDate = maxByFutureLimit || oneYearFromToday;

      return finalMaxDate.toISOString().split("T")[0];
    };


    const getMaxEnddate = () => {
      let maxByFutureLimit = null;

      if (PORTAL_SETTINGS?.leave_apply_future_limit) {
        const date = new Date(today);
        date.setDate(date.getDate() + parseInt(PORTAL_SETTINGS.leave_apply_future_limit + 1));
        maxByFutureLimit = date;
      }

      if (!referenceDate || isNaN(referenceDate.getTime())) {
        return "";
      }
      // Last day of the month of the referenceDate
      const lastDayOfMonth = new Date(referenceDate.getFullYear(), referenceDate.getMonth() + 1, 0);

      // if (dataa.date) {
      //   maxByFutureLimit = lastDayOfMonth
      // }
      if (startDate) {
        maxByFutureLimit = lastDayOfMonth;
      }
      // Choose whichever comes earlier: future limit or end of month
      // let finalMaxDate;
      // if (maxByFutureLimit) {
      //   finalMaxDate = maxByFutureLimit < lastDayOfMonth ? maxByFutureLimit : lastDayOfMonth;
      // } else {
      //   finalMaxDate = lastDayOfMonth;
      // }

      let finalMaxDate;
      if (maxByFutureLimit) {
        finalMaxDate = maxByFutureLimit;
      } else {
        finalMaxDate = lastDayOfMonth;
      }

      // const finalMaxDate = maxByFutureLimit
      //   ? (maxByFutureLimit < lastDayOfMonth ? maxByFutureLimit : lastDayOfMonth)
      //   : lastDayOfMonth;



      // return finalMaxDate.toISOString().split("T")[0];
      return toLocalISODate(finalMaxDate);

    };

    return {
      minDate: getMinDate() || undefined,
      maxStartDate: getMaxStartDate() || undefined,
      maxEndDate: getMaxEnddate() || undefined,
    };
  };

  const getDateLimitsWithDefaults = (startDate) => {
    const referenceDate = startDate ? new Date(startDate) : new Date();
    const getMinDate = () => {
      if (PORTAL_SETTINGS?.leave_apply_past_limit) {
        const date = new Date(referenceDate);
        date.setDate(date.getDate() - parseInt(PORTAL_SETTINGS.leave_apply_past_limit) + 1);
        return date.toISOString().split("T")[0];
      }
      return formattedLastDate;
    };
    const getMaxDate = () => {
      if (PORTAL_SETTINGS?.leave_apply_future_limit) {
        const date = new Date(referenceDate);
        date.setDate(date.getDate() + parseInt(PORTAL_SETTINGS.leave_apply_future_limit) + 1);
        return date.toISOString().split("T")[0];
      }
      return new Date(
        referenceDate.getFullYear(),
        referenceDate.getMonth() + 1,
        0 // Last day of current month (0th day of next month)
      ).toISOString().split("T")[0];
    };
    return {
      minDate: getMinDate(),
      maxDate: getMaxDate()
    };
  };

  const calculateDaysBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const differenceInTime = end.getTime() - start.getTime();
    return differenceInTime / (1000 * 3600 * 24) + 1; // +1 to include the start date
  };

  const checkLeaveBalance = () => {
    let numberOfDays = calculateDaysBetweenDates(dataa.date, dataa.end_date);

    if (age === "halfdayleave") {
      numberOfDays = 0.5;
    } else if (age === "shortleave") {
      // numberOfDays = 0.25;
      numberOfDays = 1;
    }

    let balance = 0;

    switch (dataa.leave_type) {
      case "previous leave":
        balance = leavebalance.leavebalance || 0;
        break;
      case "casual leave":
        balance = leavebalance.casual_leave || 0;
        break;
      case "sick leave":
        balance = leavebalance.sick_leave || 0;
        break;
      case "earn leave":
        balance = leavebalance.earn_leave || 0;
        break;
      case "short leave":
        balance = leavebalance.short_leave || 0;
        break;
      default:
        balance = 0;
        break;
    }

    if (numberOfDays > balance) {
      setInsufficientBalanceError(`You are applying for ${numberOfDays} ${numberOfDays > 1 ? 'days' : 'day'}, but you only have ${balance} ${dataa.leave_type} balance`);
    } else {
      setInsufficientBalanceError("");
    }
  };

  useEffect(() => {
    if (dataa.date && dataa.end_date && dataa.leave_type) {
      checkLeaveBalance();
    }
  }, [dataa.date, dataa.end_date, dataa.leave_type]);


  // let handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (isDateAdjusted) {
  //     const confirmApply = toast.info(
  //       `Leave will be applied from ${formattedDateLong(dataa.date)} to ${formattedDateLong(dataa.end_date)}. Do you want to continue?`
  //     );

  //     if (!confirmApply) return;
  //   }

  //   // Run validation for date fields before submission
  //   if (dataa.date) {
  //     // Validate start date
  //     validateAndSetDate(dataa.date, 'date');

  //     // If there's a date selection error from validation, stop submission
  //     if (dateselectionError) {
  //       return;
  //     }
  //   }

  //   // For multi-day, also validate end_date
  //   if (age === "multiple" && dataa.end_date) {
  //     validateAndSetDate(dataa.end_date, 'end_date');

  //     if (dateselectionError) {
  //       return;
  //     }
  //   }

  //   const updatedFormData = {
  //     ...dataa,
  //     leave_Duration: age,
  //     apply_datetime: new Date().toISOString(),
  //   };

  //   if (validateForm()) {
  //     setLoading(true); // loading logic
  //     const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
  //     try {
  //       let res = await axios.post(
  //         `${BASE_URL}/wfm/leaveapply/`,
  //         updatedFormData
  //       );

  //       if (res.status === 200) {
  //         toast.success("Leave Applied!")
  //         handleClose()

  //       } else {
  //         // alert(res);
  //         // toast.done('Done processing your request.')
  //         toast.info(res)

  //       }
  //     } catch (err) {
  //       // handleErrorToast(err, loadingToastId)
  //       handleAllError(err, loadingToastId)
  //     } finally {
  //       setLoading(false); //loading logic
  //       toast.dismiss(loadingToastId);
  //     }
  //   }
  // };

  const submitLeave = async () => {
    const updatedFormData = {
      ...dataa,
      leave_Duration: age,
      apply_datetime: new Date().toISOString(),
    };

    if (!validateForm()) return;

    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.post(
        `${BASE_URL}/wfm/leaveapply/`,
        updatedFormData
      );

      if (res.status === 200) {
        toast.success("Leave Applied!");
        handleClose();
      } else {
        toast.info(res);
      }
    } catch (err) {
      handleAllError(err, loadingToastId);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Step 1: Validate date fields FIRST
    if (dataa.date) {
      validateAndSetDate(dataa.date, "date");
      if (dateselectionError) return;
    }

    if (age === "multiple" && dataa.end_date) {
      validateAndSetDate(dataa.end_date, "end_date");
      if (dateselectionError) return;
    }

    if (isDateAdjusted) {
      showConfirmToast({
        message: `Leave will be applied from ${formattedDateLong(dataa.date)} to ${formattedDateLong(dataa.end_date)}. Do you want to continue?`,

        onConfirm: () => {
          submitLeave(); // API call
        },

        onCancel: () => {
          console.log("User cancelled");
        }
      });

      return;
    }

    //  Step 3: Normal flow (no adjustment)
    submitLeave();
  };

  const validateAndSetDate = (selectedDate, field) => {
    const { minDate, maxDate } = getDateLimitsNoRestrictions(dataa.date);
    const dateToCheck = new Date(selectedDate);
    let adjustedDate = selectedDate;
    let errorMessage = "";

    // Check minimum date re
    // striction
    if (minDate && dateToCheck < new Date(minDate)) {
      adjustedDate = minDate;
      errorMessage = `Selected date changed from "${formattedDateLong(selectedDate)}" to "${formattedDateLong(minDate)}" (minimum allowed date), As per Company Restrictions.`;
    }

    // Check maximum date restriction (only if minimum check passed)
    else if (maxDate && dateToCheck > new Date(maxDate)) {
      adjustedDate = maxDate;
      errorMessage = `Selected date changed from "${formattedDateLong(selectedDate)}" to "${formattedDateLong(maxDate)}" (maximum allowed date), As per Company Restrictions.`;
    }

    else if (field === "date" && dataa?.end_date) {
      const newStartDate = new Date(selectedDate);
      const currentEndDate = new Date(dataa.end_date);

      const startMonth = newStartDate.getMonth();
      const startYear = newStartDate.getFullYear();

      const endMonth = currentEndDate.getMonth();
      const endYear = currentEndDate.getFullYear();

      if (startMonth !== endMonth || startYear !== endYear) {
        // Force end_date to the last day of the same month as new start date
        const monthEnd = new Date(startYear, startMonth + 1, 0);

        const updatedData = {
          ...dataa,
          date: selectedDate, // keep new start date
          // end_date: monthEnd.toISOString().split("T")[0], // adjust end date
          end_date: toLocalISODate(monthEnd), // adjust end date
        };

        errorMessage = `End date must be within the same month as start date (${formattedDateLong(selectedDate)}). End date adjusted to ${formattedDateLong(updatedData.end_date)}.`;

        setdataa(updatedData);
        setDateselectionError(errorMessage);
        return; // stop here, don’t continue to normal flow
      }
    }

    // Apply adjustments if needed
    if (errorMessage) {
      const updatedData = { ...dataa, [field]: adjustedDate };
      // For single day leave types, update both date and end_date
      if (['single', 'halfdayleave', 'shortleave'].includes(age)) {
        updatedData.end_date = adjustedDate;
      }
      setdataa(updatedData);
      setDateselectionError(errorMessage);
    } else {
      setdataa({ ...dataa, [field]: selectedDate });
      setDateselectionError("");
    }
  };


  const getMinimumAllowedDate = () => {
    const today = new Date();

    if (PORTAL_SETTINGS?.leave_apply_past_limit) {
      const date = new Date(today);
      date.setDate(date.getDate() - parseInt(PORTAL_SETTINGS.leave_apply_past_limit) + 1);
      return date.toISOString().split("T")[0];
    }

    // If no past limit is set, return "2026-03-01" as the earliest
    return "2026-03-01";
  };

  const [eligibleDates, setEligibleDates] = useState([]);

  const getShortleaveApplicableDates = async () => {
    const minStartDate = getMinimumAllowedDate();
    const payload = {
      "start_date": minStartDate,
      // "start_date": "2026-01-01",
      // "end_date": "2026-02-28",
      "compensatory_type": "apply",
      "data_format": "details"
    }

    setBuffering(true);
    // const loadingToastId = toast.loading("Fetching eligible dates...");
    // const emp_code = sessionStorage.getItem("emp_code")
    try {
      let res = await axios.post(
        `${BASE_URL}/wfm/get-compensatoryapplicabledates-byemp/${dataa.empcode}/`,
        payload
      );

      if (res.status === 200) {

        // Store only the eligible_dates array
        setEligibleDates(res.data.eligible_dates || []);

        console.log('Full Response:', res.data);
        console.log('Eligible Dates:', res.data.eligible_dates);

        // toast.dismiss(loadingToastId);
        // toast.success("Data fetched successfully!");
      } else {
        toast.info(res);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      handleErrorToast(err);
    } finally {
      setBuffering(false);
      // toast.dismiss(loadingToastId);
    }
  };

  useEffect(() => {
    if (age === "shortleave") {
      getShortleaveApplicableDates();
    }

  }, [age]);

  // You can access the eligible dates data like this:
  console.log('Stored eligible dates:', eligibleDates);
  console.log(dataa, 'dataa')
  const handleDateSelect = (e) => {
    const selectedDate = e.target.value;
    setdataa({
      ...dataa,
      date: selectedDate,
      end_date: selectedDate
    });
  };

  const validateDateField = (field, value, currentData) => {
    // ✅ Allow typing freely until full date (YYYY-MM-DD)
    if (!isFullValidDate(value)) {
      return {
        updatedData: { ...currentData, [field]: value },
        errorMessage: ""
      };
    }



    let updatedData = { ...currentData, [field]: value };
    let errorMessage = "";

    const startDate = updatedData.date ? new Date(updatedData.date) : null;
    const endDate = updatedData.end_date ? new Date(updatedData.end_date) : null;

    const { minDate, maxStartDate, maxEndDate } = getDateLimitsNoRestrictions(updatedData.date);;

    //  Min Date
    if (minDate && new Date(value) < new Date(minDate)) {
      updatedData[field] = minDate;
      errorMessage = `Date adjusted to minimum allowed (${formattedDateLong(minDate)})`;
    }

    //  Max Start Date
    if (field === "date" && maxStartDate && new Date(value) > new Date(maxStartDate)) {
      updatedData.date = maxStartDate;
      errorMessage = `Start date adjusted to maximum allowed (${formattedDateLong(maxStartDate)})`;
    }

    //  Max End Date
    if (field === "end_date" && maxEndDate && new Date(value) > new Date(maxEndDate)) {
      updatedData.end_date = maxEndDate;
      errorMessage = `End date adjusted to maximum allowed (${formattedDateLong(maxEndDate)})`;
    }

    //  Same Month Restriction (IMPORTANT 🔥)
    // if (updatedData.date && updatedData.end_date) {
    if (
      isFullValidDate(updatedData.date) &&
      isFullValidDate(updatedData.end_date)
    ) {
      if (isFullValidDate(updatedData.date) && isFullValidDate(updatedData.end_date)) {

        const s = new Date(updatedData.date);
        const e = new Date(updatedData.end_date);

        if (s.getMonth() !== e.getMonth() || s.getFullYear() !== e.getFullYear()) {
          const monthEnd = new Date(s.getFullYear(), s.getMonth() + 1, 0);

          updatedData.end_date = toLocalISODate(monthEnd);

          errorMessage = `End date must be in same month. Adjusted to ${formattedDateLong(updatedData.end_date)}`;
        }
      }
    }

    //  Sync for single types
    if (['single', 'halfdayleave', 'shortleave'].includes(age)) {
      updatedData.end_date = updatedData.date;
    }

    return { updatedData, errorMessage };
  };

  const handleDateChange = (field, value) => {
    const { updatedData, errorMessage } = validateDateField(field, value, dataa);

    setdataa(updatedData);
    setDateselectionError(errorMessage);
  };

  const handleDateBlur = (field, value) => {

    // ✅ Only run when full valid date
    if (!isFullValidDate(value)) return;

    let updatedData = { ...dataa, [field]: value };
    let errorMessage = "";
    let isAdjusted = false; // ✅ track locally

    const { minDate, maxStartDate, maxEndDate } =
      getDateLimitsNoRestrictions(updatedData.date);

    // ✅ Min date restriction
    if (minDate && new Date(value) < new Date(minDate)) {
      updatedData[field] = minDate;
      errorMessage = `Date adjusted to minimum allowed (${formattedDateLong(minDate)})`;
      isAdjusted = true;
    }

    // ✅ Max start date
    if (field === "date" && maxStartDate && new Date(value) > new Date(maxStartDate)) {
      updatedData.date = maxStartDate;
      errorMessage = `Start date adjusted to maximum allowed (${formattedDateLong(maxStartDate)})`;
      isAdjusted = true;
    }

    // ✅ Max end date
    if (field === "end_date" && maxEndDate && new Date(value) > new Date(maxEndDate)) {
      updatedData.end_date = maxEndDate;
      errorMessage = `End date adjusted to maximum allowed (${formattedDateLong(maxEndDate)})`;
      isAdjusted = true;
    }

    // 🔥 Same month restriction (ONLY ONCE ✅)
    if (
      isFullValidDate(updatedData.date) &&
      isFullValidDate(updatedData.end_date)
    ) {
      const s = new Date(updatedData.date);
      const e = new Date(updatedData.end_date);

      if (s.getMonth() !== e.getMonth() || s.getFullYear() !== e.getFullYear()) {
        const monthEnd = new Date(s.getFullYear(), s.getMonth() + 1, 0);

        // ✅ ONLY update end date
        updatedData.end_date = toLocalISODate(monthEnd);

        errorMessage = `End date must be within same month. Adjusted to ${formattedDateLong(updatedData.end_date)}`;

        isAdjusted = true;
      }
    }

    // ✅ set global flag once
    setIsDateAdjusted(isAdjusted);

    setdataa(updatedData);
    setDateselectionError(errorMessage);
  };

  const blockManualDateInput = (e) => {
    // Allow Tab so keyboard-only users can still navigate between fields
    if (e.key === "Tab") return;
    e.preventDefault();
  };

  const blockDatePaste = (e) => {
    e.preventDefault();
  };

  const isShortLeaveDisabled = PORTAL_SETTINGS?.eligible_for_shortleave_credit === false;

  const hasShortLeaveTab = !isShortLeaveDisabled || (leavebalance.short_leave || 0) > 0;

  return (
    <div>
      <form>
        <div className="flex-column single-day-date">
          <div className="leave-balance-container">
            <h2 className="leave-balance-heading align-center">All Available Leaves:</h2>
            <div className="leave-balance-cards">

              {/* Previous Leave Card - Expanded/Compact based on state */}
              <div className={`leave-balance-card leave-balance-card-previous ${expandedCards.previous ? 'expanded' : 'compact'}`}>
                <div className="leave-balance-icon">&#128197;</div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Previous Leave :</span>
                  <div className={`leave-balance-details flex-row ${expandedCards.previous ? 'expanded' : 'compact'}`}>
                    <span className="leave-balance-duration">
                      {leavebalance.leavebalance ? `${leavebalance.leavebalance}` : "0"}
                    </span>
                    {/* {expandedCards.previous && ( */}
                    <span className="leave-balance-unit">
                      {leavebalance.leavebalance > 1 ? ' days' : ' day'}
                    </span>
                    {/* )} */}
                  </div>
                </div>
              </div>

              {/* Casual Leave Card */}
              <div className={`leave-balance-card leave-balance-card-casual ${expandedCards.casual ? 'expanded' : 'compact'}`}>
                <div className="leave-balance-icon">&#128215;</div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Casual Leave :</span>
                  <div className={`leave-balance-details flex-row ${expandedCards.casual ? 'expanded' : 'compact'}`}>
                    <span className="leave-balance-duration">
                      {leavebalance.casual_leave ? `${leavebalance.casual_leave}` : "0"}
                    </span>
                    {/* {expandedCards.casual && ( */}
                    <span className="leave-balance-unit">
                      {leavebalance.casual_leave > 1 ? ' days' : ' day'}
                    </span>
                    {/* )} */}
                  </div>
                </div>
              </div>

              {/* Sick Leave Card */}
              <div className={`leave-balance-card leave-balance-card-sick ${expandedCards.sick ? 'expanded' : 'compact'}`}>
                <div className="leave-balance-icon">&#128138;</div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Sick Leave :</span>
                  <div className={`leave-balance-details flex-row ${expandedCards.sick ? 'expanded' : 'compact'}`}>
                    <span className="leave-balance-duration">
                      {leavebalance.sick_leave ? `${leavebalance.sick_leave}` : "0"}
                    </span>
                    {/* {expandedCards.sick && ( */}
                    <span className="leave-balance-unit">
                      {leavebalance.sick_leave > 1 ? ' days' : ' day'}
                    </span>
                    {/* )} */}
                  </div>
                </div>
              </div>

              {/* Earned Leave Card */}
              <div className={`leave-balance-card leave-balance-card-earned ${expandedCards.earned ? 'expanded' : 'compact'}`}>
                <div className="leave-balance-icon">&#127942;</div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Earned Leave :</span>
                  <div className={`leave-balance-details flex-row ${expandedCards.earned ? 'expanded' : 'compact'}`}>
                    <span className="leave-balance-duration">
                      {leavebalance.earn_leave ? `${leavebalance.earn_leave}` : "0"}
                    </span>
                    {/* {expandedCards.earned && ( */}
                    <span className="leave-balance-unit">
                      {leavebalance.earn_leave > 1 ? ' days' : ' day'}
                    </span>
                    {/* )} */}
                  </div>
                </div>
              </div>

              {/* Short Leave Card - Highlights when compact mode is active */}
              <div className={`leave-balance-card leave-balance-card-short ${expandedCards.short ? 'expanded' : 'compact'} ${age === 'shortleave' ? 'active-compact' : ''}`}>
                <div className="leave-balance-icon">⏱️</div>
                <div className="leave-balance-info">
                  <span className="leave-balance-label">Short Leave :</span>
                  <div className={`leave-balance-details flex-row ${expandedCards.short ? 'expanded' : 'compact'}`}>
                    <span className="leave-balance-duration">
                      {leavebalance.short_leave ? `${leavebalance.short_leave}` : "0"}
                    </span>
                    {/* {expandedCards.short && ( */}
                    <span className="leave-balance-unit">
                      {leavebalance.short_leave > 1 ? ' days' : ' day'}
                    </span>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <br /> */}

          <div className="leave-duration-heading  font-weight500 font-size-heading">Leave Duration</div>
          <div
            className={`leave-duration-tabs ${hasShortLeaveTab ? '' : 'three-tabs'}`}
            onChange={(e) => {
              setdataa(prev => ({
                ...prev,
                date: "",
                end_date: "",
                leave_type: e.target.value === 'shortleave' ? 'short leave' : "",
              }));
              setErrors({});
              setAge(e.target.value)
              console.log(e.target.value, 'target values')
            }}
          >
            <input type="radio" id="leave-single-day" name="leave-type" value="single" defaultChecked />
            <label htmlFor="leave-single-day" className="leave-tab">Single Day</label>

            <input type="radio" id="leave-multi-day" name="leave-type" value="multiple" />
            <label htmlFor="leave-multi-day" className="leave-tab">Multi Day</label>

            <input type="radio" id="leave-half-day" name="leave-type" value="halfdayleave" />
            <label htmlFor="leave-half-day" className="leave-tab">Half Day</label>

            {hasShortLeaveTab && (
              <>
                <input type="radio" id="leave-short-day" name="leave-type" value="shortleave" />
                <label htmlFor="leave-short-day" className="leave-tab">Short Day</label>
              </>
            )}

            {/* <input type="radio" id="leave-short-day" name="leave-type" value="shortleave" />
            <label htmlFor="leave-short-day" className="leave-tab">Short Day </label> */}

            <span className="leave-tab-glider"></span>
          </div>

        </div>

        {age === "single" && (
          <div className="flex-column">
            <label htmlFor="date" className="form-labels font-weight500 font-size-subheading">
              Date
            </label>
            <input
              id="date"
              type="date"
              className="form-input font-weight500 form-input-background"
              value={dataa.date}
              onInput={(e) => setdataa({ ...dataa, date: e.target.value, end_date: e.target.value })}
              onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
              onKeyDown={blockManualDateInput}
              onPaste={blockDatePaste}
              min={getDateLimitsNoRestrictions(dataa.date).minDate}
              max={getDateLimitsNoRestrictions(dataa.date).maxStartDate}
            />
          </div>
        )}

        {age === "multiple" && (
          <div className="flex-row multi-day-input">
            <div className="flex-column multi-day">
              <label className="form-labels font-weight500 font-size-subheading">From Date</label>
              <input
                type="date"
                className="multi-day-input1 form-input-background"
                value={dataa.date}
                // onInput={(e) => {
                //   const startDate = e.target.value;
                //   setdataa({ ...dataa, date: startDate });
                //   const { maxDate } = getDateLimitsNoRestrictions(startDate);
                //   setMaxEndDate(maxDate);
                // }}
                onChange={(e) => {
                  setdataa({ ...dataa, date: e.target.value });
                }}
                onBlur={(e) => handleDateBlur("date", e.target.value)}
                onKeyDown={blockManualDateInput}
                onPaste={blockDatePaste}
                // onChange={(e) => handleDateChange("date", e.target.value)}
                // onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
                min={getDateLimitsNoRestrictions(dataa.date).minDate}
                max={dataa.end_date ? dataa.end_date : getDateLimitsNoRestrictions(dataa.date).maxStartDate}
              />
            </div>
            <div className="flex-column multi-day">
              <label className="form-labels font-weight500 font-size-subheading">To Date</label>
              <input
                type="date"
                className="multi-day-input1 form-input-background"
                value={dataa.end_date}
                onChange={(e) => {
                  setdataa({ ...dataa, end_date: e.target.value });
                }}
                onBlur={(e) => handleDateBlur("end_date", e.target.value)}
                onKeyDown={blockManualDateInput}
                onPaste={blockDatePaste}
                // onChange={(e) => handleDateChange("end_date", e.target.value)}
                // onChange={(e) => setdataa({ ...dataa, end_date: e.target.value })}
                // onBlur={(e) => validateAndSetDate(e.target.value, 'end_date')}
                min={dataa.date || getDateLimitsNoRestrictions(dataa.date).minDate}
                max={getDateLimitsNoRestrictions(dataa.date).maxEndDate}
              />
            </div>
          </div>
        )}

        {age === "halfdayleave" && (
          <div>
            <div className="flex-column ">
              <label className="form-labels  font-weight500    font-size-subheading">Date</label>
              <input
                id="date"
                type="date"
                className="form-input font-weight500 form-input-background"
                value={dataa.date}
                onInput={(e) => setdataa({ ...dataa, date: e.target.value, end_date: e.target.value })}
                onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
                onKeyDown={blockManualDateInput}
                onPaste={blockDatePaste}
                min={getDateLimitsNoRestrictions(dataa.date).minDate}
                max={getDateLimitsNoRestrictions(dataa.date).maxStartDate}
              />
            </div>

            <div
              required
              className="leave-duration-tabs leave-halfday-tabs single-day-date"
              onChange={(e) => {
                console.log(e.target.value, "halfday value");
              }}
            >
              <input
                type="radio"
                id="first-half"
                name="halfday"
                value="firsthalf"
                defaultChecked
              />
              <label htmlFor="first-half" className="leave-tab">
                First Half
              </label>

              <input
                type="radio"
                id="second-half"
                name="halfday"
                value="secondhalf"
              />
              <label htmlFor="second-half" className="leave-tab">
                Second Half
              </label>

              <span className="leave-tab-glider halfday-glider"></span>
            </div>
          </div>
        )}

        {/* {age === "shortleave" && (
          <div>
            <div className="flex-column single-day-date">
              <label className="form-labels  font-weight500    font-size-subheading">Date</label>
              <input
                id="date"
                type="date"
                className="form-input   font-weight500   form-input-background"
                // onChange={(e) =>
                //   setdataa({
                //     ...dataa,
                //     date: e.target.value,
                //     end_date: e.target.value,
                //   })
                // }
                value={dataa.date}
                onInput={(e) => setdataa({ ...dataa, date: e.target.value, end_date: e.target.value })}
                onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
                // min={formattedLastDate}
                min={sessionStorage.getItem("company") === "Civilmantra" ? fourDaylimit : formattedLastDate}
              />
            </div>
            <div className="flex-row multi-day-input">
              <div className="flex-column multi-day">
                <label className="form-labels  font-weight500    font-size-subheading">Start Time</label>
                <input
                  className="multi-day-input1 form-input-background"
                  type="time"
                  step="1"
                  min="09:30:00"
                  max="16:30:00"
                  onChange={(e) => getEndTime(e.target.value)}
                />
              </div>
              <div className="flex-column multi-day">
                <label className="form-labels  font-weight500    font-size-subheading">End Time</label>
                <input
                  className="multi-day-input1 form-input-background"
                  type="time"
                  step="1"
                  min="09:30:00"
                  max="16:30:00"
                  value={dataa.out_time}
                  readOnly
                />
              </div>
            </div>
          </div>
        )} */}

        {age === "shortleave" && (
          <div>
            <div className="flex-column">
              <label className="form-labels font-weight500 font-size-subheading">
                Select Date <span className="required">*</span>
              </label>
              {buffer ?
                <div className="form-loader">
                  <div className="bar-loader"></div>
                </div>
                :
                <>
                  <Select
                    options={eligibleDates
                      .filter(item => item.short_leave_applicable === true &&
                        !['rlm', 'ontime'].includes(item.day_status))
                      .map(item => ({
                        value: item.date,
                        label: formattedDateLong(item.date),
                        isDisabled: item.has_leave === true,
                        item: item // Store original item for custom rendering
                      }))}
                    value={dataa.date ? {
                      value: dataa.date,
                      label: formattedDateLong(dataa.date),
                      item: eligibleDates.find(d => d.date === dataa.date)
                    } : null}
                    onChange={(selectedOption) => {
                      // Create a synthetic event to maintain compatibility with existing handleDateSelect
                      const event = {
                        target: {
                          value: selectedOption ? selectedOption.value : ''
                        }
                      };
                      handleDateSelect(event);
                    }}
                    isClearable
                    placeholder="-- Select a Date --"
                    formatOptionLabel={(option, { context }) => (
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <span>{option.label}</span>
                        <div style={{ display: 'flex', gap: '8px' }}>

                          {option.item?.short_leave_applicable && !option.item?.has_leave && (
                            <span style={{
                              backgroundColor: '#64da64',
                              color: 'white',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: '11px',
                              fontWeight: '500',
                              whiteSpace: 'nowrap'
                            }}>
                              Short Leave Applicable
                            </span>
                          )}
                          {option.item?.has_leave && (
                            <span style={{
                              backgroundColor: '#ff4444',
                              color: 'white',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: '11px',
                              fontWeight: '500',
                              whiteSpace: 'nowrap'
                            }}>
                              Leave Applied
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    styles={CustomCSSForSearchableSelect}
                  />
                  {errors.date && (
                    <>
                      <div className="single-day-date"></div>
                      <span className="error-message font-size-text ">{errors.date}</span>
                    </>
                  )}
                </>}
            </div>
            <div className="flex-row multi-day-input">
              <div className="flex-column multi-day">
                <label className="form-labels  font-weight500    font-size-subheading">Start Time</label>
                <input
                  className="multi-day-input1 form-input-background"
                  type="time"
                  step="1"
                  min="09:30:00"
                  max="16:30:00"
                  onChange={(e) => getEndTime(e.target.value)}
                />
              </div>
              <div className="flex-column multi-day">
                <label className="form-labels  font-weight500 font-size-subheading">End Time</label>
                <input
                  className="multi-day-input1 form-input-background"
                  type="time"
                  step="1"
                  min="09:30:00"
                  max="16:30:00"
                  value={dataa.out_time}
                  readOnly
                  title="Auto fill on selecting Start Time()"
                  style={{ cursor: 'not-allowed' }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Leave Type */}
        {age != "shortleave" &&
          (
            <div className="flex-column">
              <label className="form-labels  font-weight500    font-size-subheading">Leave Type</label>
              <select
                id="leave_type"
                name="leave_type"
                type="text"
                value={dataa.leave_type}
                className={`form-input `}
                onChange={(e) => {
                  if (e.target.value.length >= 3) {
                    setdataa({ ...dataa, leave_type: e.target.value })
                    setTypeError(""); // Clear error message if within the limit
                  } else {
                    setTypeError("Ensure this field is selected.");
                  }
                }}
              >

                {/* {leavebalance.casual_leave > 0 || leavebalance.sick_leave > 0 ? null :
              <>
                <option value="previous leave">Previous Leave</option>
                <option value="earn leave">Earned Leave</option>
              </>
            } */}
                <option value="">Select Leave Type</option>
                <option value="casual leave">Casual Leave</option>
                <option value="sick leave">Sick Leave</option>
                <option value="earn leave">Earned Leave</option>
                <option value="previous leave">Previous Leave</option>
                {/* {age === "shortleave" &&
                  !(sessionStorage.getItem("company") === "Civilmantra" && (leavebalance.short_leave || 0) <= 0) &&
                  <option value="short_leave">Short Leave</option>} */}
                {age === "shortleave" &&
                  !(isShortLeaveDisabled && (leavebalance.short_leave || 0) <= 0) &&
                  <option value="short_leave">Short Leave</option>}
              </select>

              {typeError && (
                <div style={{ color: "red", marginTop: "5px" }}>{typeError}</div>
              )}
              {errors.leave_type && (
                <span className="error-message font-size-text ">{errors.leave_type}</span>
              )}
            </div>
          )}
        <div className="flex-column">
          <label className="form-labels  font-weight500    font-size-subheading">Description</label>
          <textarea
            className="form-input-textarea   font-weight400  form-input-background"
            placeholder="Reason"
            type="text"
            value={dataa.text}
            onChange={(e) => {
              if (e.target.value.length <= 50) {
                setdataa({ ...dataa, remarks: e.target.value });
                setRemarksError(""); // Clear error message if within the limit
              } else {
                setRemarksError(
                  "Ensure this field has no more than 50 characters."
                );
              }
            }}
          />

          {remarksError && (
            <div style={{ color: "red", marginTop: "5px" }}>{remarksError}</div>
          )}
          {errors.remarks && (
            <span className="error-message font-size-text ">{errors.remarks}</span>
          )}
        </div>

        {insufficientBalanceError
          && (
            <div className="flex-column" style={{ marginTop: "5px" }}>
              <div style={{ color: "red" }}>{insufficientBalanceError}</div>
              <div className="flex-row gap-2">

                <label className="checkbox-click" style={{ height: '16px' }}>
                  <input
                    id="confirm-check"
                    type="checkbox"
                    checked={insufficientBalanceConfirmation}
                    onChange={(e) => setInsufficientBalanceConfirmation(e.target.checked)}
                  />
                  <div className="checkmark-small "></div>
                </label>
                <label htmlFor="confirm-check" style={{ cursor: 'pointer' }} className="form-labels flex-column  font-weight500    font-size-subheading">
                  <span>
                    Click to confirm and proceed with Insufficient leave balance
                  </span>
                  <span>  {age === "shortleave" ? "(Day will be marked as unpaid shortleave)" : " (Note: Leaves will be deducted from other leave balances)"} </span>
                </label>
              </div>

            </div>
          )}
        {dateselectionError === "" ? null : (
          <div className="flex-column" style={{ marginTop: "5px" }}>
            <div style={{ color: "red" }}>
              Note:
              <br />
              {dateselectionError}
            </div>
          </div>
        )}

        <div className="button-models">
          <button className="model-button font-weight500 model-button-cancel" type="button" onClick={handleClose}>Cancel</button>

          <button
            className={`model-button ${(insufficientBalanceError && !insufficientBalanceConfirmation) === true ? 'model-button-cancel' : 'model-button-leave  font-weight500   '} `}
            onClick={handleSubmit}
            disabled={loading || (insufficientBalanceError && !insufficientBalanceConfirmation)}
          >
            {(insufficientBalanceError && !insufficientBalanceConfirmation) === true ? "Confirmation Needed" : "Leave"}

          </button>

        </div>
      </form >
      <ToastContainer position="top-center" hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

    </div >
  );
};


const Outduty = ({ handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [age, setAge] = useState("single");

  const [maxEndDate, setMaxEndDate] = useState(null);
  const [dateselectionError, setDateselectionError] = useState("");
  const { PORTAL_SETTINGS } = usePermission();
  const [isDateAdjusted, setIsDateAdjusted] = useState(false);
  const initialData = {
    empcode: sessionStorage.getItem("emp_code"),
    date: "",
    end_date: "",
    remarks: "",
  }
  const [dataa, setdataa] = useState({
    empcode: sessionStorage.getItem("emp_code"),
    date: "",
    end_date: "",
    remarks: "",
  });

  // !  ************** Validation start **************  ! //
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [confirmSubmit, setConfirmSubmit] = useState(false);
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "remarks",
    ];
    requiredFields.forEach((field) => {
      if (!dataa[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });
    if (!dataa.remarks.trim()) {
      newErrors.remarks = "Remarks cannot be empty or contain only spaces!";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const getEndTime = (intime) => {
    const start = new Date(`2023-03-25T${intime}`);
    const end = new Date(start.getTime() + 2 * 60 * 60 * 1000); // Add 2 hours in milliseconds
    const hh = String(end.getHours()).padStart(2, "0");
    const mm = String(end.getMinutes()).padStart(2, "0");
    const ss = String(end.getSeconds()).padStart(2, "0");

    setdataa({ ...dataa, in_time: intime, out_time: `${hh}:${mm}:${ss}` });
  };

  const date = new Date();


  const [remarksError, setRemarksError] = useState("");

  let lastDateOfPreviousMonth;
  if (date.getDate() > 20) {
    lastDateOfPreviousMonth = new Date(date.getFullYear(), date.getMonth(), 0);
  } else {
    lastDateOfPreviousMonth = new Date(date.getFullYear(), date.getMonth() - 1, +1);
  }

  const formattedLastDate = lastDateOfPreviousMonth.toISOString().substr(0, 10);

  const toLocalISODate = (date) => {
    if (!date || isNaN(date.getTime())) return "";
    const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return local.toISOString().split("T")[0];
  };

  const isFullValidDate = (val) => {
    return /^\d{4}-\d{2}-\d{2}$/.test(val) && !isNaN(new Date(val).getTime());
  };

  const getDateLimitsNoRestrictions = (startDate) => {

    const isFullValidDate = (val) =>
      /^\d{4}-\d{2}-\d{2}$/.test(val) && !isNaN(new Date(val).getTime());

    const today = new Date();
    const referenceDate = isFullValidDate(startDate) ? new Date(startDate) : today;

    const getMinDate = () => {
      if (PORTAL_SETTINGS?.od_apply_past_limit) {
        const date = new Date(today);
        date.setDate(date.getDate() - parseInt(PORTAL_SETTINGS.od_apply_past_limit) + 1);
        return date.toISOString().split("T")[0];
      }
      return null;
    };


    // const getMaxStartDate = () => {
    //   let maxByFutureLimit = null;

    //   if (PORTAL_SETTINGS?.od_apply_future_limit) {
    //     const date = new Date(today);
    //     date.setDate(date.getDate() + parseInt(PORTAL_SETTINGS.od_apply_future_limit + 1));
    //     maxByFutureLimit = date;
    //   }

    //   // If no future limit is set, allow indefinitely (no restriction)
    //   const finalMaxDate = maxByFutureLimit || new Date("2999-12-31");

    //   return finalMaxDate.toISOString().split("T")[0];
    // };

    const getMaxStartDate = () => {
      let maxByFutureLimit = null;

      if (PORTAL_SETTINGS?.leave_apply_future_limit) {
        const date = new Date(today);
        date.setDate(date.getDate() + parseInt(PORTAL_SETTINGS.leave_apply_future_limit + 1));
        maxByFutureLimit = date;
      }

      // Default cap: exactly one year from today, instead of the old "2999-12-31" (no real limit)
      const oneYearFromToday = new Date(today);
      oneYearFromToday.setDate(oneYearFromToday.getDate() + 365);

      const finalMaxDate = maxByFutureLimit || oneYearFromToday;

      return finalMaxDate.toISOString().split("T")[0];
    };


    const getMaxEnddate = () => {
      let maxByFutureLimit = null;

      if (PORTAL_SETTINGS?.od_apply_future_limit) {
        const date = new Date(today);
        date.setDate(date.getDate() + parseInt(PORTAL_SETTINGS.od_apply_future_limit + 1));
        maxByFutureLimit = date;
      }

      if (!referenceDate || isNaN(referenceDate.getTime())) {
        return "";
      }

      // Last day of the month of the referenceDate
      const lastDayOfMonth = new Date(referenceDate.getFullYear(), referenceDate.getMonth() + 1, 0);

      // if (dataa.date) {
      //   maxByFutureLimit = lastDayOfMonth
      // }
      if (startDate) {
        maxByFutureLimit = lastDayOfMonth;
      }

      let finalMaxDate;
      if (maxByFutureLimit) {
        finalMaxDate = maxByFutureLimit;
      } else {
        finalMaxDate = lastDayOfMonth;
      }

      return toLocalISODate(finalMaxDate);

    };

    return {
      minDate: getMinDate() || undefined,
      maxStartDate: getMaxStartDate() || undefined,
      maxEndDate: getMaxEnddate() || undefined,
    };
  };

  const getDateLimitsWithDefaults = (startDate) => {
    const referenceDate = startDate ? new Date(startDate) : new Date();
    const getMinDate = () => {
      if (PORTAL_SETTINGS?.od_apply_past_limit) {
        const date = new Date(referenceDate);
        date.setDate(date.getDate() - parseInt(PORTAL_SETTINGS.od_apply_past_limit) + 1);
        return date.toISOString().split("T")[0];
      }
      return formattedLastDate;
    };
    const getMaxDate = () => {
      if (PORTAL_SETTINGS?.od_apply_future_limit) {
        const date = new Date(referenceDate);
        date.setDate(date.getDate() + parseInt(PORTAL_SETTINGS.od_apply_future_limit) + 1);
        return date.toISOString().split("T")[0];
      }
      return new Date(
        referenceDate.getFullYear(),
        referenceDate.getMonth() + 1,
        0 // Last day of current month (0th day of next month)
      ).toISOString().split("T")[0];
    };
    return {
      minDate: getMinDate(),
      maxDate: getMaxDate()
    };
  };

  const submitOutDuty = async () => {
    const updatedFormData = {
      ...dataa,
      outduty_Duration: age,
      apply_datetime: new Date().toISOString(),
    };

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      setLoading(true); //loading logic

      try {
        let res = await axios.post(
          `${BASE_URL}/wfm/outduty/`,
          updatedFormData
        );

        if (res.status === 200) {
          handleClose()
        } else {
          toast.info(res)
        }
      } catch (err) {
        // handleErrorToast(err, loadingToastId)
        handleAllError(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  }

  let handleSubmit = async (e) => {
    e.preventDefault();

    // // First click -> only show message
    // if (isDateAdjusted && !confirmSubmit) {
    //   toast.info(
    //     `Out Duty will be applied from ${formattedDateLong(dataa.date)} to ${formattedDateLong(dataa.end_date)}. Click submit again to confirm.`
    //   );

    //   setConfirmSubmit(true); //  mark confirmed
    //   return;
    // }


    if (isDateAdjusted && !confirmSubmit) {
      showConfirmToast({
        message: `Out Duty will be applied from ${formattedDateLong(dataa.date)} to ${formattedDateLong(dataa.end_date)}. Do you want to continue?`,

        onConfirm: () => {
          submitOutDuty(); //  API call
        },

        onCancel: () => {
          console.log("User cancelled");
        }
      });

      return;
    }

    //  Reset flag after confirmation
    setConfirmSubmit(false);

    // // Run validation for date fields before submission
    // if (dataa.date) {
    //   // Validate start date
    //   validateAndSetDate(dataa.date, 'date');

    //   // If there's a date selection error from validation, stop submission
    //   if (dateselectionError) {
    //     return;
    //   }
    // }

    // // For multi-day, also validate end_date
    // if (age === "multiple" && dataa.end_date) {
    //   validateAndSetDate(dataa.end_date, 'end_date');

    //   if (dateselectionError) {
    //     return;
    //   }
    // }

    submitOutDuty()

  };

  const validateAndSetDate = (selectedDate, field) => {
    const { minDate, maxDate } = getDateLimitsNoRestrictions(dataa.date);
    const dateToCheck = new Date(selectedDate);
    let adjustedDate = selectedDate;
    let errorMessage = "";

    if (minDate && dateToCheck < new Date(minDate)) {
      adjustedDate = minDate;
      errorMessage = `Selected date changed from "${formattedDateLong(selectedDate)}" to "${formattedDateLong(minDate)}" (minimum allowed date), As per Company Restrictions.`;
    }

    else if (maxDate && dateToCheck > new Date(maxDate)) {
      adjustedDate = maxDate;
      errorMessage = `Selected date changed from "${formattedDateLong(selectedDate)}" to "${formattedDateLong(maxDate)}" (maximum allowed date), As per Company Restrictions.`;
    }

    else if (field === "date" && dataa?.end_date) {
      const newStartDate = new Date(selectedDate);
      const currentEndDate = new Date(dataa.end_date);

      const startMonth = newStartDate.getMonth();
      const startYear = newStartDate.getFullYear();

      const endMonth = currentEndDate.getMonth();
      const endYear = currentEndDate.getFullYear();

      if (startMonth !== endMonth || startYear !== endYear) {
        // Force end_date to the last day of the same month as new start date
        const monthEnd = new Date(startYear, startMonth + 1, 0);

        const updatedData = {
          ...dataa,
          date: selectedDate, // keep new start date
          // end_date: monthEnd.toISOString().split("T")[0], // adjust end date
          end_date: toLocalISODate(monthEnd), // adjust end date
        };

        errorMessage = `End date must be within the same month as start date (${formattedDateLong(selectedDate)}). End date adjusted to ${formattedDateLong(updatedData.end_date)}.`;

        setdataa(updatedData);
        setDateselectionError(errorMessage);
        return; // stop here, don’t continue to normal flow
      }
    }

    if (errorMessage) {
      const updatedData = { ...dataa, [field]: adjustedDate };
      if (['single', 'halfdayleave', 'shortleave'].includes(age)) {
        updatedData.end_date = adjustedDate;
      }
      setdataa(updatedData);
      setDateselectionError(errorMessage);
    } else {
      setdataa({ ...dataa, [field]: selectedDate });
      setDateselectionError("");
    }
  };

  const validateDateField = (field, value, currentData) => {
    // ✅ Allow typing freely until full date (YYYY-MM-DD)
    if (!isFullValidDate(value)) {
      return {
        updatedData: { ...currentData, [field]: value },
        errorMessage: ""
      };
    }



    let updatedData = { ...currentData, [field]: value };
    let errorMessage = "";

    const startDate = updatedData.date ? new Date(updatedData.date) : null;
    const endDate = updatedData.end_date ? new Date(updatedData.end_date) : null;

    const { minDate, maxStartDate, maxEndDate } = getDateLimitsNoRestrictions(updatedData.date);;

    //  Min Date
    if (minDate && new Date(value) < new Date(minDate)) {
      updatedData[field] = minDate;
      errorMessage = `Date adjusted to minimum allowed (${formattedDateLong(minDate)})`;
    }

    //  Max Start Date
    if (field === "date" && maxStartDate && new Date(value) > new Date(maxStartDate)) {
      updatedData.date = maxStartDate;
      errorMessage = `Start date adjusted to maximum allowed (${formattedDateLong(maxStartDate)})`;
    }

    //  Max End Date
    if (field === "end_date" && maxEndDate && new Date(value) > new Date(maxEndDate)) {
      updatedData.end_date = maxEndDate;
      errorMessage = `End date adjusted to maximum allowed (${formattedDateLong(maxEndDate)})`;
    }

    //  Same Month Restriction (IMPORTANT 🔥)
    // if (updatedData.date && updatedData.end_date) {
    if (
      isFullValidDate(updatedData.date) &&
      isFullValidDate(updatedData.end_date)
    ) {
      if (isFullValidDate(updatedData.date) && isFullValidDate(updatedData.end_date)) {

        const s = new Date(updatedData.date);
        const e = new Date(updatedData.end_date);

        if (s.getMonth() !== e.getMonth() || s.getFullYear() !== e.getFullYear()) {
          const monthEnd = new Date(s.getFullYear(), s.getMonth() + 1, 0);

          updatedData.end_date = toLocalISODate(monthEnd);

          errorMessage = `End date must be in same month. Adjusted to ${formattedDateLong(updatedData.end_date)}`;
        }
      }
    }

    //  Sync for single types
    if (['single', 'halfdayleave', 'shortleave'].includes(age)) {
      updatedData.end_date = updatedData.date;
    }

    return { updatedData, errorMessage };
  };

  const handleDateBlur = (field, value) => {

    // ✅ Only run when full valid date
    if (!isFullValidDate(value)) return;

    let updatedData = { ...dataa, [field]: value };
    let errorMessage = "";
    let isAdjusted = false; // ✅ track locally

    const { minDate, maxStartDate, maxEndDate } =
      getDateLimitsNoRestrictions(updatedData.date);

    // ✅ Min date restriction
    if (minDate && new Date(value) < new Date(minDate)) {
      updatedData[field] = minDate;
      errorMessage = `Date adjusted to minimum allowed (${formattedDateLong(minDate)})`;
      isAdjusted = true;
    }

    // ✅ Max start date
    if (field === "date" && maxStartDate && new Date(value) > new Date(maxStartDate)) {
      updatedData.date = maxStartDate;
      errorMessage = `Start date adjusted to maximum allowed (${formattedDateLong(maxStartDate)})`;
      isAdjusted = true;
    }

    // ✅ Max end date
    if (field === "end_date" && maxEndDate && new Date(value) > new Date(maxEndDate)) {
      updatedData.end_date = maxEndDate;
      errorMessage = `End date adjusted to maximum allowed (${formattedDateLong(maxEndDate)})`;
      isAdjusted = true;
    }

    // 🔥 Same month restriction (ONLY ONCE ✅)
    if (
      isFullValidDate(updatedData.date) &&
      isFullValidDate(updatedData.end_date)
    ) {
      const s = new Date(updatedData.date);
      const e = new Date(updatedData.end_date);

      if (s.getMonth() !== e.getMonth() || s.getFullYear() !== e.getFullYear()) {
        const monthEnd = new Date(s.getFullYear(), s.getMonth() + 1, 0);

        // ✅ ONLY update end date
        updatedData.end_date = toLocalISODate(monthEnd);

        errorMessage = `End date must be within same month. Adjusted to ${formattedDateLong(updatedData.end_date)}`;

        isAdjusted = true;
      }
    }

    // ✅ set global flag once
    setIsDateAdjusted(isAdjusted);

    setdataa(updatedData);
    setDateselectionError(errorMessage);
  };

  const blockManualDateInput = (e) => {
    // Allow Tab so keyboard-only users can still navigate between fields
    if (e.key === "Tab") return;
    e.preventDefault();
  };

  const blockDatePaste = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      <form>
        <div className="flex-column model-age">

          <div className="leave-duration-heading  font-weight500 font-size-heading">Outduty Duration </div>
          <div
            className="leave-duration-tabs"
            onChange={(e) => {
              setdataa(initialData)
              setAge(e.target.value)
            }}
          >
            <input type="radio" id="leave-single-day" name="leave-type" value="single" defaultChecked />
            <label htmlFor="leave-single-day" className="leave-tab">Single Day</label>

            <input type="radio" id="leave-multi-day" name="leave-type" value="multiple" />
            <label htmlFor="leave-multi-day" className="leave-tab">Multi Day</label>

            <input type="radio" id="leave-half-day" name="leave-type" value="halfdayleave" />
            <label htmlFor="leave-half-day" className="leave-tab">Half Day</label>

            <input type="radio" id="leave-short-day" name="leave-type" value="shortleave" />
            <label htmlFor="leave-short-day" className="leave-tab">Short Day</label>

            <span className="leave-tab-glider"></span>
          </div>
        </div>


        {/* {age === "single" && (
          <div className="flex-column">
            <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
              Date
            </label>
            <input
              id="date"
              type="date"
              className="form-input   font-weight500   form-input-background"
              value={dataa.date}
              onInput={(e) => setdataa({ ...dataa, date: e.target.value, end_date: e.target.value })}
              onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
              min={sessionStorage.getItem("company") === "Civilmantra" ? fourDaylimit : formattedLastDate}
            />
          </div>
        )} */}

        {age === "single" && (
          <div className="flex-column">
            <label htmlFor="date" className="form-labels font-weight500 font-size-subheading">
              Date
            </label>
            <input
              id="date"
              type="date"
              className="form-input font-weight500 form-input-background"
              value={dataa.date}
              onInput={(e) => setdataa({ ...dataa, date: e.target.value, end_date: e.target.value })}
              onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
              onKeyDown={blockManualDateInput}
              onPaste={blockDatePaste}
              min={getDateLimitsNoRestrictions(dataa.date).minDate}
              max={getDateLimitsNoRestrictions(dataa.date).maxStartDate}
            />
          </div>
        )}

        {/* {age === "multiple" && (
          <div className="flex-row multi-day-input">
            <div className="flex-column multi-day">
              <label className="form-labels  font-weight500    font-size-subheading">From Date</label>
              <input
                type="date"
                className="multi-day-input1 form-input-background"
                value={dataa.date}
                onInput={(e) => setdataa({ ...dataa, date: e.target.value })}
                onBlur={(e) => {
                  const startDate = e.target.value;
                  if (!startDate || isNaN(new Date(startDate))) {
                    console.error("Invalid start date:", startDate);
                    return; // Exit early if the date is invalid
                  }
                  validateAndSetDate(startDate, 'date');
                  const lastDate = new Date(
                    new Date(startDate).getFullYear(),
                    new Date(startDate).getMonth() + 1,
                    1
                  )
                    .toISOString()
                    .split("T")[0];
                  setMaxEndDate(lastDate);

                  if (dataa.end_date && new Date(dataa.end_date) < new Date(startDate)) {
                    setdataa({ ...dataa, end_date: startDate });
                  }
                }}
                min={sessionStorage.getItem("company") === "Civilmantra" ? fourDaylimit : formattedLastDate}
              />
            </div>
            <div className="flex-column multi-day">
              <label className="form-labels  font-weight500    font-size-subheading">To Date</label>
              <input
                type="date"
                className="multi-day-input1 form-input-background"
                onChange={(e) =>
                  setdataa({ ...dataa, end_date: e.target.value })
                }
                min={dataa.date || formattedDate} // Ensure end date is not before the start date
                max={maxEndDate}
              />
            </div>
          </div>
        )} */}

        {age === "multiple" && (
          <div className="flex-row multi-day-input">
            <div className="flex-column multi-day">
              <label className="form-labels font-weight500 font-size-subheading">From Date</label>
              <input
                type="date"
                className="multi-day-input1 form-input-background"
                value={dataa.date}
                // onInput={(e) => {
                //   const startDate = e.target.value;
                //   setdataa({ ...dataa, date: startDate });
                //   const { maxDate } = getDateLimitsNoRestrictions(startDate);
                //   setMaxEndDate(maxDate);
                // }}
                onChange={(e) => {
                  setdataa({ ...dataa, date: e.target.value });
                }}
                onBlur={(e) => handleDateBlur("date", e.target.value)}
                onKeyDown={blockManualDateInput}
                onPaste={blockDatePaste}

                // onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
                min={getDateLimitsNoRestrictions(dataa.date).minDate}
                max={dataa.end_date ? dataa.end_date : getDateLimitsNoRestrictions(dataa.date).maxStartDate}
              />
            </div>
            <div className="flex-column multi-day">
              <label className="form-labels font-weight500 font-size-subheading">To Date</label>
              <input
                type="date"
                className="multi-day-input1 form-input-background"
                value={dataa.end_date}
                onChange={(e) => {
                  setdataa({ ...dataa, end_date: e.target.value });
                }}
                onBlur={(e) => handleDateBlur("end_date", e.target.value)}
                onKeyDown={blockManualDateInput}
                onPaste={blockDatePaste}

                // onChange={(e) => setdataa({ ...dataa, end_date: e.target.value })}
                // onBlur={(e) => validateAndSetDate(e.target.value, 'end_date')}
                min={dataa.date || getDateLimitsNoRestrictions(dataa.date).minDate}
                max={getDateLimitsNoRestrictions(dataa.date).maxEndDate}
              />
            </div>
          </div>
        )}

        {/* {age === "halfdayleave" && (
          <div>
            <div className="flex-column single-day-date">
              <label className="form-labels  font-weight500    font-size-subheading">Date</label>
              <input
                type="date"
                className="form-input   font-weight500   form-input-background"
                     value={dataa.date}
                onInput={(e) => setdataa({ ...dataa, date: e.target.value, end_date: e.target.value })}
                onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
                min={sessionStorage.getItem("company") === "Civilmantra" ? fourDaylimit : formattedLastDate}
              />
            </div>
            <div
              required
              className="leave-radio-button"
            >
              <div className="leave-radio-button-inner-div">
                <input
                  name="halfday"
                  type="radio"
                  value="firsthalft"
                  className="age-input"
                  in_time="09:30:00"
                  out_time="13:30:00"
                />
                <label className="age-label   font-weight500    font-size-heading">First Half</label>
              </div>
              <div className="leave-radio-button-inner-div">
                <input
                  name="halfday"
                  type="radio"
                  value="secondhalft"
                  className="age-input"
                  in_time="14:30:00"
                  out_time="18:30:00"
                />
                <label className="age-label   font-weight500    font-size-heading">Second Half</label>
              </div>
            </div>
          </div>
        )} */}

        {age === "halfdayleave" && (
          <div>
            <div className="flex-column">
              <label className="form-labels  font-weight500    font-size-subheading">Date</label>
              <input
                id="date"
                type="date"
                className="form-input font-weight500 form-input-background"
                value={dataa.date}
                onInput={(e) => setdataa({ ...dataa, date: e.target.value, end_date: e.target.value })}
                onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
                onKeyDown={blockManualDateInput}
                onPaste={blockDatePaste}
                min={getDateLimitsNoRestrictions(dataa.date).minDate}
                max={getDateLimitsNoRestrictions(dataa.date).maxStartDate}
              />
            </div>

            <div
              required
              className="leave-duration-tabs leave-halfday-tabs single-day-date"
              onChange={(e) => {
                console.log(e.target.value, "halfday value");
              }}
            >
              <input
                type="radio"
                id="first-half"
                name="halfday"
                value="firsthalf"
                defaultChecked
              />
              <label htmlFor="first-half" className="leave-tab">
                First Half
              </label>

              <input
                type="radio"
                id="second-half"
                name="halfday"
                value="secondhalf"
              />
              <label htmlFor="second-half" className="leave-tab">
                Second Half
              </label>

              <span className="leave-tab-glider halfday-glider"></span>
            </div>
          </div>
        )}

        {/* {age === "shortleave" && (
          <div>
            <div className="flex-column single-day-date">
              <label className="form-labels  font-weight500    font-size-subheading">Date</label>
              <input
                type="date"
                className="form-input   font-weight500   form-input-background"
                value={dataa.date}
                onInput={(e) => setdataa({ ...dataa, date: e.target.value, end_date: e.target.value })}
                onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
                min={sessionStorage.getItem("company") === "Civilmantra" ? fourDaylimit : formattedLastDate}
              />
            </div>
            <div className="flex-row multi-day-input">
              <div className="flex-column multi-day">
                <label className="form-labels  font-weight500    font-size-subheading">Start Time</label>
                <input
                  className="multi-day-input1 form-input-background"
                  type="time"
                  step="1"
                  min="09:30:00"
                  max="16:30:00"
                  onChange={(e) => getEndTime(e.target.value)}
                />
              </div>
              <div className="flex-column multi-day">
                <label className="form-labels  font-weight500    font-size-subheading">End Time</label>
                <input
                  className="multi-day-input1 form-input-background"
                  type="time"
                  step="1"
                  min="09:30:00"
                  max="16:30:00"
                  value={dataa.out_time}
                  readOnly
                />
              </div>
            </div>
          </div>
        )} */}

        {age === "shortleave" && (
          <div>
            <div className="flex-column">
              <label className="form-labels  font-weight500    font-size-subheading">Date</label>
              <input
                id="date"
                type="date"
                className="form-input font-weight500 form-input-background"
                value={dataa.date}
                onInput={(e) => setdataa({ ...dataa, date: e.target.value, end_date: e.target.value })}
                onBlur={(e) => validateAndSetDate(e.target.value, 'date')}
                onKeyDown={blockManualDateInput}
                onPaste={blockDatePaste}
                min={getDateLimitsNoRestrictions(dataa.date).minDate}
                max={getDateLimitsNoRestrictions(dataa.date).maxStartDate}
              />
            </div>
            <div className="flex-row multi-day-input">
              <div className="flex-column multi-day">
                <label className="form-labels  font-weight500    font-size-subheading">Start Time</label>
                <input
                  className="multi-day-input1 form-input-background"
                  type="time"
                  step="1"
                  min="09:30:00"
                  max="16:30:00"
                  onChange={(e) => getEndTime(e.target.value)}
                />
              </div>
              <div className="flex-column multi-day">
                <label className="form-labels  font-weight500    font-size-subheading">End Time</label>
                <input
                  className="multi-day-input1 form-input-background"
                  type="time"
                  step="1"
                  min="09:30:00"
                  max="16:30:00"
                  value={dataa.out_time}
                  readOnly
                  title="Auto fill on selecting Start Time()"
                  style={{ cursor: 'not-allowed' }}
                />
              </div>
            </div>
          </div>
        )}

        <div className="flex-column">
          <label className="form-labels  font-weight500    font-size-subheading">Location & Work performed</label>
          <textarea
            className="form-input-textarea   font-weight400  form-input-background"
            placeholder="Description"
            type="text"
            value={dataa.text}
            onChange={(e) => {
              if (e.target.value.length <= 50) {
                setdataa({ ...dataa, remarks: e.target.value });
                setRemarksError(""); // Clear error message if within the limit
              } else {
                setRemarksError(
                  "Ensure this field has no more than 50 characters."
                );
              }
            }}
          />

          {remarksError && (
            <div style={{ color: "red", marginTop: "5px" }}>{remarksError}</div>
          )}
          {errors.remarks && (
            <span className="error-message font-size-text ">{errors.remarks}</span>
          )}
        </div>
        {dateselectionError === "" ? null : (
          <div className="flex-column" style={{ marginTop: "5px" }}>
            <div style={{ color: "red" }}>
              Note:
              <br />
              {dateselectionError}
            </div>
          </div>
        )}
        <div className="button-models">
          <button className="model-button font-weight500 model-button-cancel" type="button" onClick={handleClose}>Cancel</button>
          <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleSubmit} disabled={loading} >{/* //loading logic */}
            Outduty
          </button>
        </div>
      </form>
      <ToastContainer position="top-center" hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

    </div>
  );
};


const AssignTask = ({ handleClose }) => {
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [empList, setEmpList] = useState([]);
  const [loading, setLoading] = useState(false); //loading logic

  // *********** Employee Code Api Start ***********
  // const [emp_code, setEmp_code] = useState([]);
  const getAllEmp_code = async (toggleCompany) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
      );

      const sortedList = customSortByKey(res.data, "emp_code");

      setEmpList(sortedList);
      // setEmp_code(res.data);
    } catch (err) {
      // alert(err.message);
    }
  };


  const [formData, setFormData] = useState({
    task: "",
    assignedby: sessionStorage.getItem("emp_code"),
    assigndate: formattedDate,
    concern_person: "",
    status: "pending",
    priority: "",
    due_date: "",
    assignedtocc: "",
  });

  useEffect(() => {
    getAllEmp_code(toggleCompany);
  }, [formData]);

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [priority, setPriority] = useState("3");

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["task", "due_date", "concern_person"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [buffer, setBuffering] = useState(false); //buffering logic

  const handleCompanyChange = async (val) => {
    setBuffering(true)
    setToggleCompany(val);
    let toggleCompanyval = val;
    await getAllEmp_code(toggleCompanyval);
    setBuffering(false)
  };
  console.log("toggleState");
  console.log(toggleCompany);


  const handleInputChange = (e) => {
    // getAllEmp_code();

    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (formData.assignedtocc.length === 0) {
      formData.assignedtocc = [formData.concern_person];
    }
    const updatedFormData = {
      ...formData,
      priority: priority,

    };
    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/tasks/`, updatedFormData);

        if (res.status === 200) {
          handleClose();
        } else {
          alert(res);
        }
      } catch (err) {
        console.log(err);
        // alert(err);
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };



  const [searchTerm, setSearchTerm] = useState('');

  const options = empList
    .filter((e) => e.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code)).map((e) => ({
      value: e.emp_code,
      label: `${e.emp_code} - ${e.name}`,
    }));

  const handleChangecc = (selected) => {
    const assignedtocc = selected.length > 0 ? selected.map((item) => item.value) : null;
    setFormData((prevState) => ({
      ...prevState,
      assignedtocc,
    }));
  };

  const blockManualDateInput = (e) => {
    // Allow Tab so keyboard-only users can still navigate between fields
    if (e.key === "Tab") return;
    e.preventDefault();
  };

  const blockDatePaste = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      <form>
        <div className="flex-column">
          <label className="form-labels  font-weight500    font-size-subheading">Task</label>
          <textarea
            placeholder="Task Description"
            type="text"
            name="task"
            maxLength={300}
            onChange={handleInputChange}
            value={formData.task}
            className={`form-input-textarea   font-weight400  form-input form-input-background ${errors.task ? "error" : inputState.task ? "success" : ""
              }`}

          />
          {errors.task && (
            <span className="error-message font-size-text ">{errors.task}</span>
          )}
        </div>

        <div className="flex-column">
          <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
            Deadline Date
          </label>
          <input
            id="date"
            type="date"
            name="due_date"
            onChange={handleInputChange}
            onKeyDown={blockManualDateInput}
            onPaste={blockDatePaste}
            value={formData.due_date}
            className={`form-input form-input-background ${errors.due_date ? "error" : inputState.due_date ? "success" : ""
              }`}
          />
          {errors.due_date && (
            <span className="error-message font-size-text ">{errors.due_date}</span>
          )}
        </div>

        <div className="leave-duration  font-weight500   -heading  font-weight400  font-size-heading">Priority </div>
        <div
          value={priority}
          onChange={(e) => setPriority(e.target.value)}
          className="leave-radio-button"
        >
          <div className="leave-radio-button-inner-div">
            <input
              name="priority"
              type="radio"
              value="3"
              checked={priority === "3"}
              className="age-input"
            />
            <label className="age-label   font-weight500    font-size-heading">Low</label>
          </div>
          <div className="leave-radio-button-inner-div">
            <input
              name="priority"
              type="radio"
              value="2"
              checked={priority === "2"}
              className="age-input"
            />
            <label className="age-label   font-weight500    font-size-heading">Medium</label>
          </div>
          <div className="leave-radio-button-inner-div">
            <input
              name="priority"
              type="radio"
              value="1"
              checked={priority === "1"}
              className="age-input"
            />
            <label className="age-label   font-weight500    font-size-heading">High</label>
          </div>
        </div>

        {PERMISSION_AUTHORITY ?
          <div className="flex-column form-group-select">
            <br />
            <label className="form-labels  font-weight500    font-size-subheading">
              Sub Company<span className="required">*</span>
            </label>
            <br />
            <select
              name="subcompany"
              onChange={(e) => {
                handleCompanyChange(e.target.value);
              }}
              value={toggleCompany}
              className={`form-input form-group-selection form-input-background ${errors.concern_person
                ? "error"
                : inputState.concern_person
                  ? "success"
                  : ""
                }`}
            >
              <option value="null">Select Sub Company</option>
              {SUB_COMPANIES.map((company) => (
                <option value={company.id}>{company.title}</option>
              ))}

            </select>
            <div className="form-group-selection-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="25"
                fill="currentColor"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            </div>
          </div>
          : null}


        <br />

        <div className="flex-column form-group-select">
          <label className="form-labels  font-weight500    font-size-subheading">
            Assign To<span className="required">*</span>
          </label>
          <br />
          {buffer ? (
            <div className="spinner-vsmall"></div>
          ) : <>
            <select
              name="concern_person"
              onChange={handleInputChange}
              value={formData.concern_person}
              className={`form-input form-group-selection form-input-background ${errors.concern_person
                ? "error"
                : inputState.concern_person
                  ? "success"
                  : ""
                }`}
            >
              <option value="">Select Employee</option>
              {empList
                .sort((a, b) => a.emp_code - b.emp_code)
                .map((i, index) => (
                  <option value={i.emp_code}>
                    {i.name} - {i.emp_code}
                  </option>
                ))}

            </select>
            <div className="form-group-selection-arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="25"
                fill="currentColor"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            </div>

          </>
          }
          {errors.concern_person && (
            <span className="error-message font-size-text ">{errors.concern_person}</span>
          )}
        </div>


        <div className='flex-column form-group-select'>
          <label className="form-labels  font-weight500    font-size-subheading">CC</label>

          {buffer ? (
            <div className="spinner-vsmall"></div>
          ) : <Select
            options={options}
            isMulti
            onChange={handleChangecc}
            className={`form-group-selection form-input-background `}
          />}
        </div>

        <div className="button-models">
          <button className="model-button   font-weight500  model-button-cancel  ">Cancel</button>
          <button
            className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
            onClick={handleFormSubmit}
            disabled={loading}
          >
            {/* //loading logic */}
            Assign
          </button>
        </div>
      </form>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

    </div>
  );
};


const Applymodels = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // toggle state 1 for SC 2 for CIPL/GENG
  const [toggleState, setToggleState] = useState(
    sessionStorage.getItem("company") === "Space Creattors" ||
      sessionStorage.getItem("company") === "Space Creattors Heights"
      ? 1 : 2);

  return (
    <>
      <button
        className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
        onClick={handleShow}
        style={{ padding: "10px 20px" }}
      >
        Apply
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >

        <Modal.Body>
          <div>
            <div>
              <div className="bloc-tabs-apply4">

                {/*  //? @SC Customization */}
                {/* view in SC hide for CIPL/GENG */}
                {sessionStorage.getItem("company") === "Space Creattors" ||
                  sessionStorage.getItem("company") ===
                  "Space Creattors Heights" ? (
                  <button
                    className={
                      toggleState === 1
                        ? "dashboardcomponent-tabs-apply   font-weight400  font-size-subheading  dashboardcomponent-active-tabs"
                        : "dashboardcomponent-tabs-apply  font-weight400  font-size-subheading  "
                    }
                    onClick={() => setToggleState(1)}
                  >
                    Clock in
                  </button>
                ) : (
                  ""
                )}

                <button
                  className={
                    toggleState === 2
                      ? "dashboardcomponent-tabs-apply  font-weight400  font-size-subheading dashboardcomponent-active-tabs"
                      : "dashboardcomponent-tabs-apply  font-weight400  font-size-subheading"
                  }
                  onClick={() => setToggleState(2)}
                >
                  Apply Leave
                </button>
                <button
                  className={
                    toggleState === 4
                      ? "dashboardcomponent-tabs-apply  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                      : "dashboardcomponent-tabs-apply  font-weight400  font-size-subheading  "
                  }
                  onClick={() => setToggleState(4)}
                >
                  Out Duty
                </button>
                <button
                  className={
                    toggleState === 3
                      ? "dashboardcomponent-tabs-apply  font-weight400  font-size-subheading dashboardcomponent-active-tabs"
                      : "dashboardcomponent-tabs-apply  font-weight400  font-size-subheading"
                  }
                  onClick={() => setToggleState(3)}
                >
                  Assign Task
                </button>
              </div>
            </div>

            <div className="content-tabs ">
              {toggleState === 1 ? <Clockin handleClose={handleClose} /> : null}

              {toggleState === 2 ? <Leave handleClose={handleClose} /> : null}

              {toggleState === 3 ? <AssignTask handleClose={handleClose} /> : null}

              {toggleState === 4 ? <Outduty handleClose={handleClose} /> : null}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Applymodels;
